import { Box, Typography } from '@mui/material';
import FormateText from 'utils/FormateText';
import { ACTIVITY_BADGE_COLORS } from './activityHelpers';

const ActivityTypeBadge = ({ activityType }) => {
    const colors = ACTIVITY_BADGE_COLORS[activityType] || ACTIVITY_BADGE_COLORS.LOGIN;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: 1.25,
                py: 0.35,
                borderRadius: '999px',
                bgcolor: colors.bg,
                border: `1px solid ${colors.color}`,
                whiteSpace: 'nowrap',
            }}
        >
            <Typography sx={{ color: colors.color, fontSize: 12, fontWeight: 700, lineHeight: 1.2 }}>
                {FormateText(activityType)}
            </Typography>
        </Box>
    );
};

export default ActivityTypeBadge;
